import { useQuery } from "@apollo/client";
import { GetStorefrontTransaction, GetStorefrontTransactionVariables } from "_graphql/queries/__generated__/GetStorefrontTransaction";
import { getSupplierTransactionReference } from "_graphql/queries/payment";

export const useVerifyPaymentWithReference = (reference: string) => {
  const { data, loading, error, refetch, stopPolling } = useQuery<
    GetStorefrontTransaction,
    GetStorefrontTransactionVariables
  >(getSupplierTransactionReference, {
    variables: {
      input: {
        filter: {
          id: {
            eq: reference,
          },
        },
      },
    },
    pollInterval: 3000, // Poll every 3 seconds
    onCompleted: (data) => {
      if (data?.getStorefrontTransaction) {
        stopPolling();
      }
    },
    onError: (error) => {
      console.error("Payment verification error:", error);
    },
  });

  return {
    data: data?.getStorefrontTransaction ?? null,
    loading,
    error,
    refetch,
  };
};
